import moment from "moment";
import {
  tableVariant,
  leadStatusObj,
  taskStatusObj,
  tokenStatusObj,
  propertyStatusObj,
  targetTaskStatusOptionsObj,
  userRoleObj,
  activitySourceObj,
} from "utils/constants";

const {
  rawLead,
  polishedLead,
  tasks,
  project,
  source,
  users,
  usersMainPage,
  callRecord,
  customerContact,
  leadRequest,
  leadTasks,
  token,
  inventory,
  individualProperty,
  taskTarget,
  projectPhase,
  phaseBlocks,
  teams,
  activity,
  projectDocuments,
  sales,
} = tableVariant;
const {
  statusNew,
  statusOpen,
  statusClosedLost,
  statusClosedWon,
  tokenBooked,
  tokenExtended,
  statusDead,
} = leadStatusObj;
const { taskStatusOpen, taskStatusClosed, taskStatusPending } = taskStatusObj;
const {
  tokenStatusWon,
  tokenStatusLost,
  tokenStatusExpired,
  tokenStatusExtended,
} = tokenStatusObj;
const { propertySold, propertyBooked } = propertyStatusObj;

const { statusCompleted } = targetTaskStatusOptionsObj;

export function getTimestamp(value: string) {
  if (!value) {
    return "";
  }

  return moment(value).format("YYYY-MM-DD HH:mm:ss");
}

export function activityConversion(value: string): string[] {
  if (!value) {
    return [];
  }

  return value.split(".");
}

export function rowRedStyleCondition(data: any, tableFor: string) {
  const todayDate = moment();

  // if (tableFor === rawLead) {
  //   if (
  //     data.lead_status !== statusClosedLost &&
  //     data.lead_status !== statusClosedWon
  //   ) {
  //     if (data?.due_date === "-") {
  //       return true;
  //     }
  //     if (moment(data?.due_date).isBefore(todayDate, "day")) {
  //       return true;
  //     }
  //   }
  // }

  // if (tableFor === polishedLead) {
  //   if (
  //     data.lead_status !== statusClosedLost &&
  //     data.lead_status !== statusClosedWon
  //   ) {
  //     if (data?.due_date === "-") {
  //       return true;
  //     }
  //     if (moment(data?.due_date).isBefore(todayDate, "day")) {
  //       return true;
  //     }
  //   }
  // }

  if (tableFor === tasks || tableFor === leadTasks) {
    if (data?.task_status === taskStatusOpen) {
      return data?.due_date === "-";
    }
    if (data?.task_status === taskStatusPending) {
      return true;
    }
  }

  // if (tableFor === token) {
  //   return data?.token_status === tokenStatusExpired;
  // }

  return false;
}

function isToday(date: any) {
  return moment(date).isSame(moment(), "day");
}

export function rowStyleCondition(data: any, tableFor: string) {
  const todayDate = moment();
  if (tableFor === rawLead) {
    if (data?.lead_status === statusClosedWon) {
      return "darkGreen";
    }

    if (
      data.lead_status === statusClosedLost ||
      data.lead_status === statusDead
    ) {
      return "brown";
    }

    if (isToday(data?.due_date)) {
      return "orange";
    }

    if (data?.due_date === "-") {
      return "purple";
    }
    if (moment(data?.due_date).isBefore(todayDate, "day")) {
      return "red";
    }
  }

  if (tableFor === polishedLead) {
    if (data?.lead_status === statusClosedWon) {
      return "darkGreen";
    }

    if (
      data.lead_status === statusClosedLost ||
      data.lead_status === statusDead
    ) {
      return "brown";
    }

    if (isToday(data?.due_date)) {
      return "orange";
    }

    if (
      data?.lead_status === tokenBooked ||
      data?.lead_status === tokenExtended
    ) {
      return "lightGreen";
    }

    if (data?.due_date === "-") {
      return "purple";
    }
    if (moment(data?.due_date).isBefore(todayDate, "day")) {
      return "red";
    }
  }

  if (tableFor === inventory || tableFor === individualProperty) {
    if (data?.property_status === propertyBooked) {
      return "lightGreen";
    }

    if (data?.property_status === propertySold) {
      return "darkGreen";
    }
  }

  if (tableFor === token) {
    if (data?.token_status === tokenStatusExpired) {
      return "red";
    }

    if (data?.token_status === tokenStatusWon) {
      return "darkGreen";
    }

    if (data?.token_status === tokenStatusExtended) {
      return "lightGreen";
    }
  }

  return "";
}
export function getIdbasedOnTableVariant({ type, data }: any) {
  switch (type) {
    case rawLead:
    case polishedLead:
    case leadRequest:
      return data?.leadId;
    case tasks:
    case leadTasks:
      return data?.id;
    case project:
      return data?.projectId;
    case source:
      return data?.sourceId;
    case users:
    case usersMainPage:
      return data?.userId;
    case callRecord:
      return data?.callRecordId;
    case customerContact:
      return data?.contactId;
    case token:
      return data?.tokenId;
    case inventory:
      return data?.propertyId;
    case taskTarget:
      return data?.targetId;
    case projectPhase:
      return data?.phaseId;
    case phaseBlocks:
      return data?.blockId;
    case teams:
      return data?.team_id;
    case activity:
      return data?.activityId;
    case projectDocuments:
      return data?.documentId;
    case sales:
      return data?.saleId;

    default:
      break;
  }
}

export function isDisableBasedOnTableVariant({
  type,

  data,
  role,
}: any): boolean {
  switch (type) {
    case leadTasks:
    case tasks:
      return data?.task_status === taskStatusClosed;
    case rawLead:
    case polishedLead:
      return (
        (data?.lead_status === statusClosedLost ||
          data?.lead_status === statusClosedWon) &&
        role === userRoleObj.user
      );
    case token:
      return (
        data?.token_status === tokenStatusWon ||
        data?.token_status === tokenStatusLost
        //   &&
        // role === userRoleObj.user
      );
    case inventory:
      return data?.property_status === propertySold;
    case taskTarget:
      return data?.status === statusCompleted;
    case users:
    case usersMainPage:
      return role === userRoleObj.user;
    case teams:
      return role === userRoleObj.user;
    case callRecord:
      return [userRoleObj?.user, userRoleObj?.manager]?.includes(role);
    default:
      return false;
  }
}

export function getUrlForNavigation(data: any) {
  if (data?.teamId) {
    return `/teams/team-detail/${data?.teamId}`;
  }

  if (data?.userId) {
    return `/teams/user-detail/${data?.userId}`;
  }

  return "";
}

export function getNavigationLinkForActivityTable(data: any) {
  switch (data?.activity_source) {
    case activitySourceObj?.lead:
      return `/leads/complete-detail/${data?.sourceId}`;
    case activitySourceObj?.task:
      return `/tasks/complete-detail/${data?.sourceId}`;
    case activitySourceObj?.token:
      return `/token/complete-detail/${data?.sourceId}`;
    case activitySourceObj?.team:
      return `/teams/team-detail/${data?.sourceId}`;
    case activitySourceObj?.user:
      return `/teams/user-detail/${data?.sourceId}`;
    case activitySourceObj?.taskTarget:
      return `/add-target/complete-detail/${data?.sourceId}`;
    case activitySourceObj?.projectInventory:
      return `/property/complete-detail/${data?.sourceId}?isProjectProperty=true`;
    case activitySourceObj?.nonProjectInventory:
      return `/property/complete-detail/${data?.sourceId}?isProjectProperty=false`;

    default:
      break;
  }
}
